import React, { useEffect, useRef, useState } from "react";
import "./PropertyList.css";
import column from "../../Images/Vector (9).png";
import grid from "../../Images/Group 1171279337.png";
import grid2 from "../../Images/Group 1171279337 (1).png";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { List } from "react-window";

import PropertyGrid from "./PropertyGrid";
import PropertyColumn from "./PropertyColumn";
import Header from "../../Layout/Header";
import WhatsAppButton from "../../Component/WhatsAppButton";
import HomeService from "../../Services/HomeService";
import { floors } from "../Community/Helper";

const PropertyList = () => {
  // State declarations
  const [progress, setProgress] = useState(0);
  const [toggle, settoggle] = useState(2);
  const [show, setshow] = useState(false);
  const [userAccecebilityStatus, setUserAccecebilityStatus] = useState(null);
  const [propertyType, setPropertyType] = useState([]);
  const [bhk, setbhk] = useState([]);
  const [floor, setFloor] = useState([]);
  const [city, setCity] = useState([]);
  const [userId, setUserId] = useState("");
  const [submittedData, setSubmittedData] = useState([]);
  const [localities, setLocalities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [countSubscribedCities, setCountSubscribedCities] = useState(1);
  const [subscribedLocalities, setSubscribedLocalities] = useState([]);
  const [subscribedPropertyTypes, setSubscribedPropertyTypes] = useState([]);
  const [favPropertyId, setFavPropertyId] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [cityWiseLocality, setCityWiseLocality] = useState([]);
  const [cityWiseAppartment, setCityWiseAppartment] = useState([]);
  const [fullPropertyList, setFullPropertyList] = useState([]);
  const [isPriceFilterActive, setIsPriceFilterActive] = useState(false);

  // Search states for dropdowns
  const [localitySearchTerm, setLocalitySearchTerm] = useState("");
  const [apartmentSearchTerm, setApartmentSearchTerm] = useState("");
  const [showLocalityDropdown, setShowLocalityDropdown] = useState(false);
  const [showApartmentDropdown, setShowApartmentDropdown] = useState(false);

  // Refs for dropdowns
  const localityRef = useRef(null);
  const apartmentRef = useRef(null);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const limit = 10; // Fixed limit per page

  const location = useLocation();
  const navigate = useNavigate();
  const filteredProperty = location?.state?.filteredProperty || null;
  const cityId = location?.state?.cityId || null;
  const loggedInUserId = location?.state?.loggedInUserId;
  const [collapse, setCollapse] = useState(false);
  console.log("cityId", cityId);

  // Price range state
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(0);
  const [dragging, setDragging] = useState(null);

  const [filterData, setFilterData] = useState({
    userId: loggedInUserId || "",
    cityId: cityId || "",
    propertyType: "",
    propertyFor: "",
    locality: "",
    address: "",
    area: "",
    unit: "",
    bhk: "",
    floor: "",
    aptName: "",
    phoneNo: "",
    minArea: "",
    maxArea: "",
    name: "",
    features: [],
  });

  // this is for only home page city selection purpose
  useEffect(() => {
    if (cityId) {
      console.log("userId", loggedInUserId);
      handleFilterChange("cityId", cityId);
    }
    window.scroll(0, 0);
  }, []);

  const [searchDataOnTheGo, setSearchDataOnTheGo] = useState({});

  // Refs and hooks
  const sliderRef = useRef(null);

  useEffect(() => {
    if (cityId) {
      getLoginProfile();
      handleFilterChange("cityId", cityId);
    } else {
      fetchFullPropertyList(1);
    }
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (localityRef.current && !localityRef.current.contains(event.target)) {
        setShowLocalityDropdown(false);
      }
      if (
        apartmentRef.current &&
        !apartmentRef.current.contains(event.target)
      ) {
        setShowApartmentDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Constants
  const availableFor = [
    { name: "Sale", value: "sale" },
    { name: "Rent", value: "rent" },
  ];

  const salePriceOptions = [
    75000, 100000, 500000, 1000000, 2000000, 3000000, 5000000, 7500000,
    10000000, 20000000, 50000000, 100000000, 250000000, 500000000, 1000000000,
    1500000000, 2000000000,
  ];
  const rentPriceOptions = [
    10000, 50000, 75000, 100000, 500000, 1000000, 2000000, 3000000, 5000000,
    7500000, 10000000,
  ];
  const [priceOptions, setPriceOptions] = useState(salePriceOptions);

  // Helper functions
  const getSliderConfig = () => {
    if (filterData.propertyFor === "rent") {
      return { min: 0, max: 7500000, step: 500000 };
    } else {
      return { min: 0, max: 2000000000, step: 1000000 };
    }
  };

  const formatValue = (val) => {
    if (val >= 10000000) return `₹${(val / 10000000).toFixed(2)} Cr`;
    else if (val >= 100000) return `₹${(val / 100000).toFixed(2)} L`;
    else if (val >= 1000) return `₹${(val / 1000).toFixed(0)}K`;
    else return `₹${val}`;
  };

  // Filtered lists based on search term
  const filteredLocalities = cityWiseLocality.filter((item) =>
    item.name?.toLowerCase().includes(localitySearchTerm.toLowerCase()),
  );

  const filteredApartments = cityWiseAppartment.filter((item) =>
    item.aptName?.toLowerCase().includes(apartmentSearchTerm.toLowerCase()),
  );

  // Fetch full property list with pagination
  const fetchFullPropertyList = async (
    page = 1,
    isFavouriteClicked = false,
  ) => {
    try {
      if (!isFavouriteClicked) {
        setLoading(true);
      }
      console.log("Fetching full property list for page:", page);
      const res = await HomeService.getFullPropertyList(page);
      console.log("Full property list response:", res);

      if (res.status) {
        setFullPropertyList(res?.data || []);
        setSubmittedData(res?.data || []);

        // Set pagination data
        if (res?.pagination) {
          setTotalPages(res.pagination.totalPages);
          setTotalItems(res.pagination.totalProperties);
          setCurrentPage(res.pagination.currentPage);
        }

        setLoading(false);
        console.log("Full property data set:", res?.data);
      } else {
        toast.error(res?.message);
        setLoading(false);
      }
    } catch (error) {
      console.log("Error fetching full property list:", error);
      toast.error(error.message);
      setLoading(false);
    }
  };

  const fetchCity = async (uid) => {
    try {
      console.log("Fetching cities for user:", uid);
      const res = await HomeService?.getCities({ userId: uid });
      console.log("Cities response:", res);

      if (res?.status) {
        const subscribedLocations = res?.data?.filter(
          (loc) => loc.isSubscribedByUser,
        );

        console.log("Subscribed locations:", subscribedLocations);

        const subscribedCount = subscribedLocations.length;
        setCountSubscribedCities(subscribedCount);
        setCity(res.data);
      }
    } catch (error) {
      console.error("Error fetching city:", error);
    }
  };

  const fetchLocality = async (id) => {
    try {
      console.log("Fetching localities for city:", id);
      const res = await HomeService.getLocalitiesByCity(id);
      console.log("Localities response:", res);

      if (res?.status) {
        setLocalities(res?.data);
        setCityWiseLocality(res?.data);
        console.log("Localities set:", res?.data);

        const subscribedIds = res?.data
          .filter((item) => item.isSubscribedByUser === true)
          .map((item) => item._id);
        setSubscribedLocalities(subscribedIds);
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  const fetchPropertyType = async () => {
    try {
      const res = await HomeService.getPropertyTypes();
      console.log("Property types response:", res);

      if (res?.status) {
        setPropertyType(res.data);
        const subscribedIds = res?.data
          .filter((item) => item.isSubscribedByUser === true)
          .map((item) => item._id);
        setSubscribedPropertyTypes(subscribedIds);
      }
    } catch (error) {
      console.error("Error fetching property types:", error);
    }
  };

  // Main initialization function
  const getLoginProfile = async () => {
    try {
      console.log("Getting login profile...");
      const res = await HomeService.getLoginProfile();
      console.log("Login profile response:", res);

      if (!res.status) {
        navigate("/profile");
        return;
      }
      if (res?.status) {
        const userData = res.data;
        setUserId(userData?._id);
        console.log("User ID set:", userData?._id);

        const cityIds =
          userData?.multiSubscribedCities?.map((item) => item._id) || [];
        const localityIds =
          userData?.multiSubscribedLocalities?.map((item) => item._id) || [];
        const propertyTypeIds =
          userData?.multiSubscribedPropertyTypes?.map((item) => item._id) || [];

        const multi = {
          localities: localityIds,
          propertyTypes: propertyTypeIds,
        };

        console.log("User multi subscriptions:", multi);

        // Update filter data with user ID
        setFilterData((prev) => ({
          ...prev,
          userId: userData?._id,
        }));

        // First fetch cities with user ID
        await fetchCity(userData?._id);

        // Then fetch localities if city exists
        if (cityId || userData?.multiSubscribedCities[0]?._id) {
          const cityToFetch = cityId || userData?.multiSubscribedCities[0]?._id;
          console.log("Fetching locality for city:", cityToFetch);
          fetchLocality(cityToFetch);
          getAppartmentByCityId(cityToFetch);
        }
      }
    } catch (error) {
      console.error("Error in getLoginProfile:", error);
      toast.error("Failed to load user profile");
    }
  };

  // Modified handleSearchOnTheGo to respect price checkbox and pagination
  const handleSearchOnTheGo = async (e, searchData, page = 1) => {
    e && e.preventDefault();
    console.log("search", searchData);
    const updatedSearchData = {
      ...searchDataOnTheGo,
      ...searchData,
    };

    setSearchDataOnTheGo(updatedSearchData);

    // Base data object without price
    const data = {
      userId: userId || loggedInUserId,
      cityId: updatedSearchData.cityId || filterData.cityId,
      propertyType: updatedSearchData.propertyType,
      propertyFor: updatedSearchData.propertyFor,
      locality: updatedSearchData.locality,
      address: updatedSearchData.address,
      area: updatedSearchData.area,
      unit: updatedSearchData?.unit,
      bhk: updatedSearchData.bhk,
      floor: updatedSearchData.floor,
      aptName: updatedSearchData?.aptName,
      phoneNo: updatedSearchData?.phoneNo,
      minArea: updatedSearchData?.minArea,
      maxArea: updatedSearchData?.maxArea,
      name: updatedSearchData?.name,
      features: updatedSearchData?.features,
      // page: page,
      // limit: limit,
    };

    // Add price only if checkbox is checked
    if (isPriceFilterActive) {
      data.minPrice = updatedSearchData.minPrice || minValue;
      data.maxPrice = updatedSearchData.maxPrice || maxValue;
    }

    console.log("Searching with data:", data);

    try {
      const response = await HomeService.getPropertyList(data, page);
      console.log("Search response:", response);

      // Handle response structure
      if (response?.data && Array.isArray(response.data)) {
        setSubmittedData(response.data);

        // Set pagination data
        if (response?.pagination) {
          setTotalPages(response.pagination.totalPages);
          setTotalItems(response.pagination.totalProperties);
          setCurrentPage(response.pagination.currentPage);
        }
      }
    } catch (error) {
      console.error("Search error:", error);
      toast.error("Search failed");
    }
  };

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);

    // Check if we're using full property list or filtered search
    if (filterData.cityId) {
      handleSearchOnTheGo(null, searchDataOnTheGo, page);
    } else {
      fetchFullPropertyList(page);
    }

    // Scroll to top of property list
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Price slider functions
  const valueToPercent = (val) => {
    const { min, max } = getSliderConfig();
    return ((val - min) / (max - min)) * 100;
  };

  const percentToValue = (percent) => {
    const { min, max } = getSliderConfig();
    return min + ((max - min) * percent) / 100;
  };

  const handleMouseMove = (e) => {
    if (!dragging) return;
    const rect = sliderRef.current.getBoundingClientRect();
    let percent = ((e.clientX - rect.left) / rect.width) * 100;
    percent = Math.max(0, Math.min(100, percent));

    let rawVal = percentToValue(percent);
    let dynamicStep =
      rawVal > 10000000
        ? 10000000
        : rawVal > 100000
          ? 1000000
          : getSliderConfig().step;
    let val = Math.round(rawVal / dynamicStep) * dynamicStep;
    val = Math.min(getSliderConfig().max, Math.max(getSliderConfig().min, val));

    if (dragging === "min") {
      if (val >= maxValue) val = maxValue - dynamicStep;
      setMinValue(val);
    } else if (dragging === "max") {
      if (val <= minValue) val = minValue + dynamicStep;
      setMaxValue(val);
    }
  };

  const handleMouseUp = () => {
    setDragging(null);
    if (isPriceFilterActive) {
      handleSearchOnTheGo(null, { minPrice: minValue, maxPrice: maxValue }, 1);
    }
  };

  // Export functions
  const downloadExcel = () => {
    if (submittedData.length === 0) {
      toast.error("No data to export");
      return;
    }

    const visibleProperties = submittedData.filter(
      (property) => property.visibility === true,
    );

    if (visibleProperties.length === 0) {
      toast.error("No visible properties to export");
      return;
    }

    const worksheetData = visibleProperties.map((row, i) => ({
      "Property For": row?.propertyFor || "",
      Appartment_Name: row?.aptName,
      Locality: row?.locality?.name || "",
      Address: row?.address || "",
      Location_Url: row?.locationUrl || "",
      Area: `${row?.area || ""} ${row?.unit || ""}`,
      Floor: row?.floor || "",
      BHK: row?.bhk || "",
      Owner_Name: row?.ownerName || "",
      Owner_Number: row?.phoneNo || "",
      Extra: row?.extra || "",
      Price: `${row?.price || ""} ${row?.priceUnit || ""}  `,
      New_Entry: row?.newEntry || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Properties");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "property_list.xlsx");
  };

  const downloadPDF = () => {
    if (submittedData.length === 0) {
      toast.error("No data to export");
      return;
    }

    const visibleProperties = submittedData.filter(
      (property) => property.visibility === true,
    );

    if (visibleProperties.length === 0) {
      toast.error("No visible properties to export");
      return;
    }

    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(16);
    doc.text("Property List", 14, 20);

    const tableColumn = [
      "Property_For",
      "Appartment_Name",
      "Locality",
      "Address",
      "Area",
      "Floor",
      "BHK",
      "Owner_Name",
      "Owner_Number",
      "Extra",
      "Price",
      "New_Entry",
    ];
    const tableRows = visibleProperties.map((row) => [
      row?.propertyFor || "",
      row?.aptName || "",
      row?.locality?.name || "",
      row?.address || "",
      [row?.area, row?.unit].filter(Boolean).join(" "),
      row?.floor || "",
      row?.bhk || "",
      row?.ownerName || "",
      row?.phoneNo || "",
      row?.extra || "",
      [row?.price, row?.priceUnit].filter(Boolean).join(" "),
      row?.newEntry || "",
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 30,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185] },
    });

    doc.save("property_list.pdf");
  };

  // Event handlers
  const handleFilterChange = (field, value) => {
    console.log(`${field} changed to:`, value);

    // If city is selected, fetch locality and apartment
    if (field === "cityId" && value) {
      console.log("City selected, fetching locality and apartment for:", value);
      getLocalityByCityId(value);
      getAppartmentByCityId(value);

      // Reset locality and apartment when city changes
      setFilterData((prev) => ({
        ...prev,
        locality: "",
        aptName: "",
      }));
    }

    // If city is not selected, disable other filters
    if (field !== "cityId" && !filterData.cityId && !value) {
      toast.warning("Please select a city first");
      return;
    }

    setFilterData((prev) => ({ ...prev, [field]: value }));

    // Don't trigger search if city is not selected
    if (field === "cityId" || filterData.cityId || value) {
      handleSearchOnTheGo(null, { [field]: value }, 1); // Reset to page 1 on filter change
    }
  };

  const handleClearAll = () => {
    setFilterData({
      userId: userId,
      cityId: "",
      propertyType: "",
      propertyFor: "",
      locality: "",
      address: "",
      area: "",
      bhk: "",
      floor: "",
      priceRange: "",
      aptName: "",
      phoneNo: "",
    });
    setIsPriceFilterActive(false);
    setMinValue(0);
    setMaxValue(0);
    setCityWiseLocality([]);
    setCityWiseAppartment([]);
    setCurrentPage(1);
    setLocalitySearchTerm("");
    setApartmentSearchTerm("");
    fetchFullPropertyList(1);
  };

  const getLocalityByCityId = async (id) => {
    try {
      console.log("Getting locality for city ID:", id);
      const res = await HomeService.getLocalitiesByCity(id);
      console.log("Locality by city response:", res);

      if (res?.status) {
        setCityWiseLocality(res?.data);
        console.log("CityWiseLocality set:", res?.data);
      } else {
        setCityWiseLocality([]);
      }
    } catch (error) {
      console.error("Failed to fetch Localities:", error);
      setCityWiseLocality([]);
    }
  };

  const getAppartmentByCityId = async (id) => {
    try {
      console.log("Getting apartment for city ID:", id);
      const res = await HomeService.getAppartmentByCity(id);
      console.log("Apartment response:", res);

      if (res?.status) {
        setCityWiseAppartment(res?.data);
        console.log("CityWiseAppartment set:", res?.data);
      } else {
        setCityWiseAppartment([]);
      }
    } catch (error) {
      console.error("Failed to fetch Appartment:", error);
      setCityWiseAppartment([]);
    }
  };

  const handleClick = async (e, propertyId) => {
    if (!userId) {
      toast.error("User not logged in");
      return;
    }

    setFavPropertyId(propertyId);
    try {
      const data = { userId, propertyId };
      const res = await HomeService.addToWishList(data);
      if (res?.status) {
        setIsClicked(!isClicked);
        toast.success(res?.message);
        if (
          filterData?.cityId ||
          filterData?.propertyType ||
          filterData?.propertyFor ||
          filterData?.locality ||
          filterData?.address ||
          filterData?.area ||
          filterData?.unit ||
          filterData?.bhk
        ) {
          await handleSearchOnTheGo(e, {}, currentPage);
        } else {
          await fetchFullPropertyList(currentPage, true);
        }
      } else {
        toast.error(res?.message || "Failed to add to wishlist");
      }
    } catch (error) {
      console.error("Error adding property to wishlist:", error);
      toast.error("Failed to add property to wishlist");
    }
  };

  // Effects
  useEffect(() => {
    if (dragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    } else {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [dragging, minValue, maxValue, isPriceFilterActive]);

  useEffect(() => {
    console.log("filterData.cityId changed:", filterData?.cityId);
    if (filterData?.cityId) {
      fetchLocality(filterData?.cityId);
      getAppartmentByCityId(filterData?.cityId);
    } else {
      setLocalities([]);
      setCityWiseLocality([]);
      setCityWiseAppartment([]);
    }
  }, [filterData?.cityId]);

  useEffect(() => {
    filterData?.propertyFor === "rent"
      ? setPriceOptions(rentPriceOptions)
      : setPriceOptions(salePriceOptions);
  }, [filterData?.propertyFor]);

  // Reset slider when filter changes
  useEffect(() => {
    setMinValue(getSliderConfig().min);
    setMaxValue(getSliderConfig().max);
  }, [filterData]);

  // Modified price effect to respect checkbox
  useEffect(() => {
    if (isPriceFilterActive) {
      handleSearchOnTheGo(null, { minPrice: minValue, maxPrice: maxValue }, 1);
    }
  }, [minValue, maxValue, isPriceFilterActive]);

  // Initial data loading
  useEffect(() => {
    const initializeData = async () => {
      try {
        const fetchUserAccecibilityToDownload = async () => {
          try {
            const res = await HomeService.getUserAccecebilityToDownload();
            if (res?.status) {
              setUserAccecebilityStatus(res?.data?.visibilityAcess);
            }
          } catch (error) {
            console.error("Error fetching accessibility:", error);
          }
        };

        const fetchBanner = async () => {
          try {
            await HomeService.getBanner();
          } catch (error) {
            console.error("Error fetching banner:", error);
          }
        };

        await fetchUserAccecibilityToDownload();
        await fetchBanner();
        await fetchPropertyType();
        await getLoginProfile();

        window.scrollTo({ top: 0, behavior: "instant" });
      } catch (error) {
        console.error("Error initializing data:", error);
        toast.error("Failed to initialize data");
      }
    };

    initializeData();
  }, []);

  // Modified renderPriceSlider with checkbox
  const renderPriceSlider = () => {
    const minPercent = valueToPercent(minValue);
    const maxPercent = valueToPercent(maxValue);

    return (
      <div className="form_field_property">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "10px",
          }}
        >
          <label className="filter_property_label" style={{ marginBottom: 0 }}>
            Price Filter
          </label>
          <input
            disabled={!filterData.cityId}
            type="checkbox"
            checked={isPriceFilterActive}
            onChange={(e) => {
              setIsPriceFilterActive(e.target.checked);
              if (e.target.checked) {
                handleSearchOnTheGo(
                  null,
                  {
                    minPrice: minValue,
                    maxPrice: maxValue,
                  },
                  1,
                );
              } else {
                handleSearchOnTheGo(
                  null,
                  { minPrice: null, maxPrice: null },
                  1,
                );
              }
            }}
          />
        </div>

        {isPriceFilterActive && (
          <div className="filter_input_div">
            <div style={{ margin: "40px 10px 10px 10px" }}>
              <div
                ref={sliderRef}
                style={{
                  position: "relative",
                  height: 8,
                  background: "#ddd",
                  borderRadius: 4,
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    height: 8,
                    background: "#007bff",
                    borderRadius: 4,
                    left: `${minPercent}%`,
                    width: `${maxPercent - minPercent}%`,
                    top: 0,
                  }}
                />

                {/* Min Thumb */}
                <div
                  onMouseDown={() => setDragging("min")}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: `${minPercent}%`,
                    transform: "translate(-50%, -50%)",
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    backgroundColor: "#007bff",
                    boxShadow: "0 0 5px #007bff",
                    cursor: "pointer",
                    zIndex: dragging === "min" ? 2 : 1,
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: -30,
                      left: "50%",
                      transform: "translateX(-50%)",
                      color: "#fff",
                      fontWeight: "500",
                      fontSize: 10,
                      whiteSpace: "nowrap",
                      userSelect: "none",
                      background: "#333",
                      padding: "5px 10px",
                      borderRadius: "4px",
                    }}
                  >
                    {formatValue(minValue)}
                  </div>
                </div>

                {/* Max Thumb */}
                <div
                  onMouseDown={() => setDragging("max")}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: `${maxPercent}%`,
                    transform: "translate(-50%, -50%)",
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    backgroundColor: "#007bff",
                    boxShadow: "0 0 5px #007bff",
                    cursor: "pointer",
                    zIndex: dragging === "max" ? 2 : 1,
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: -30,
                      left: "50%",
                      transform: "translateX(-50%)",
                      color: "#fff",
                      fontWeight: "500",
                      fontSize: 10,
                      whiteSpace: "nowrap",
                      userSelect: "none",
                      background: "#333",
                      padding: "5px 10px",
                      borderRadius: "4px",
                    }}
                  >
                    {formatValue(maxValue)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  // Modified renderFilterField to disable when no city selected
  const renderFilterField = (
    label,
    field,
    type = "select",
    options = [],
    placeholder = "",
  ) => {
    const isDisabled = field !== "cityId" && !filterData.cityId;

    return (
      <div className="form_field_property">
        <label className="filter_property_label">{label}</label>
        <div className="filter_input_div">
          {type === "select" ? (
            <select
              className="filter_input"
              value={filterData[field] || ""}
              onChange={(e) => handleFilterChange(field, e.target.value)}
              disabled={isDisabled}
              style={{ backgroundColor: isDisabled ? "#f5f5f5" : "white" }}
            >
              <option value="">
                {isDisabled ? "Select city first" : `Select ${label}`}
              </option>
              {options.map((option) => (
                <option
                  key={option._id || option.value}
                  value={option._id || option.value}
                >
                  {option.name || option.propertyType || option.aptName}
                </option>
              ))}
            </select>
          ) : (
            <input
              className="filter_input"
              placeholder={isDisabled ? "Select city first" : placeholder}
              value={filterData[field] || ""}
              onChange={(e) => handleFilterChange(field, e.target.value)}
              disabled={isDisabled}
              style={{ backgroundColor: isDisabled ? "#f5f5f5" : "white" }}
            />
          )}
        </div>
      </div>
    );
  };

  const [ownerNames, setOwnerNames] = useState([]);
  const [fetchOwnerNamesLoading, setFetchOwnerNamesLoading] = useState(false);
  const [ownerNameInput, setOwnerNameInput] = useState("");
  const [isOwnerNameInputClicked, setIsOwnerNameInputClicked] = useState(false);
  const ownerRef = useRef();
  const fetchOwnerNames = async (params = filterData?.name) => {
    setFetchOwnerNamesLoading(true);
    try {
      const res = await HomeService?.getOwnerNames(params);
      if (res?.status) {
        setOwnerNames(res?.data?.slice(0, 500));
      } else {
        toast?.error(res?.message);
      }
      console.log("owner", res);
    } catch (error) {
      console.log(error);
      toast.error(error);
    } finally {
      setFetchOwnerNamesLoading(false);
    }
  };

  useEffect(() => {
    fetchOwnerNames();
  }, [filterData?.name]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // যদি click করা element ownerRef এর ভিতরে না থাকে
      if (ownerRef.current && !ownerRef.current.contains(event.target)) {
        setIsOwnerNameInputClicked(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <WhatsAppButton phoneNumber="918009903561" textMessge="Hello" />

      <Header collapse={collapse} setCollapse={setCollapse} />
      <div className={collapse ? "layout_collapsed" : ""}>
        <div className="uni_wrapper bg">
          <div className="uni_container5">
            <div className="property_list_screen_div">
              <div className="coulmn_row_div_wrapper">
                <div className="column_row_div column_row_div5662">
                  <div className="column_div55" onClick={() => setshow(!show)}>
                    <div className="column_div">
                      <i className="fa-solid fa-filter"></i>
                    </div>
                  </div>

                  <div
                    style={{ columnGap: "15px" }}
                    className="d-flex justify-content-start align-items-center"
                  >
                    <div
                      onClick={async (e) => {
                        if (
                          filterData?.cityId ||
                          filterData?.propertyType ||
                          filterData?.propertyFor ||
                          filterData?.locality ||
                          filterData?.address ||
                          filterData?.area ||
                          filterData?.unit ||
                          filterData?.bhk
                        ) {
                          await handleSearchOnTheGo(e, {}, currentPage);
                        }
                        settoggle(toggle === 1 ? 2 : 1);
                      }}
                      className={toggle == 1 ? "column_div" : " row_div"}
                    >
                      <img style={{ width: "15px" }} src={column} alt="" />
                    </div>
                    <div
                      onClick={async (e) => {
                        if (
                          filterData?.cityId ||
                          filterData?.propertyType ||
                          filterData?.propertyFor ||
                          filterData?.locality ||
                          filterData?.address ||
                          filterData?.area ||
                          filterData?.unit ||
                          filterData?.bhk
                        ) {
                          await handleSearchOnTheGo(e, {}, currentPage);
                        }
                        settoggle(toggle === 1 ? 2 : 1);
                      }}
                      className={toggle == 1 ? "row_div" : "column_div"}
                    >
                      {toggle == 1 && (
                        <img style={{ width: "15px" }} src={grid} alt="" />
                      )}
                      {toggle == 2 && (
                        <img style={{ width: "70%" }} src={grid2} alt="" />
                      )}
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      overflowX: "auto",
                      width: "100%",
                    }}
                  >
                    {console.log("city", city)}
                    {city.map((item, key) => (
                      <div
                        key={key}
                        className=""
                        style={{
                          maxWidth: "fit-content",
                          padding: "5px 10px",
                          cursor: item.isSubscribedByUser
                            ? "pointer"
                            : "default",
                          border: "solid 1px #023269",
                          backgroundColor: item.isSubscribedByUser
                            ? "#023269"
                            : "#f3f1f2",
                          color: item.isSubscribedByUser
                            ? "#ffffff"
                            : "#023269",
                          // "#79c948",
                          fontSize: "12px",
                          width: "fit-content",
                          display: "flex",
                          justifyContent: "start",
                          alignItems: "center",
                          borderRadius: "16px",
                          boxShadow: "0px 0px 4px 0px rgba(2, 50, 105, 0.33)",
                        }}
                        onClick={(e) => {
                          if (item.isSubscribedByUser) {
                            handleFilterChange("cityId", item._id);
                          } else {
                            toast.warning(
                              "You are not subscribed to this city",
                            );
                          }
                        }}
                      >
                        {!item.isSubscribedByUser && (
                          <i
                            className="fa-solid fa-lock"
                            style={{ color: "#023269", marginRight: "4px" }}
                          ></i>
                        )}
                        <p
                          style={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item.name}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="list_down_pdf_wrp">
                <h5 className="property_list_title">Properties List</h5>
                <div>
                  {userAccecebilityStatus && (
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        gap: "15px",
                      }}
                    >
                      <button onClick={downloadPDF} className="export-btn">
                        <i
                          className="fa-solid fa-download"
                          style={{ marginTop: "5px" }}
                        ></i>
                        <span style={{ fontWeight: "600" }}>PDF</span>
                      </button>
                      <button onClick={downloadExcel} className="export-btn">
                        <i
                          className="fa-solid fa-download"
                          style={{ marginTop: "5px" }}
                        ></i>
                        <span style={{ fontWeight: "600" }}>Excel</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="property_list_div_wrapper">
                {toggle == 1 ? (
                  <PropertyColumn
                    propertyData={submittedData}
                    loading={loading}
                    showFav={true}
                    activeData={true}
                    showBlurred={true}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    handleClick={handleClick}
                  />
                ) : (
                  <PropertyGrid
                    isClicked={isClicked}
                    favPropertyId={favPropertyId}
                    handleClick={handleClick}
                    propertyData={submittedData}
                    loading={loading}
                    showFav={true}
                    activeData={true}
                    showBlurred={true}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                )}

                <div
                  className="filter_property_div"
                  style={{ padding: "10px 10px" }}
                >
                  <form>
                    {/* City Dropdown */}
                    <div className="form_field_property">
                      <label className="filter_property_label">City</label>
                      <div className="filter_input_div">
                        <select
                          className="filter_input"
                          value={filterData?.cityId}
                          onChange={(e) =>
                            handleFilterChange("cityId", e.target.value)
                          }
                        >
                          <option value="">Select City</option>
                          {city?.map((option) => (
                            <option value={option._id} key={option._id}>
                              {option?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Property Type Dropdown */}
                    <div className="form_field_property">
                      <label className="filter_property_label">
                        Property Type
                      </label>
                      <div className="filter_input_div">
                        <select
                          className="filter_input"
                          value={filterData?.propertyType}
                          onChange={(e) =>
                            handleFilterChange("propertyType", e.target.value)
                          }
                          disabled={!filterData.cityId}
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        >
                          <option value="">
                            {!filterData.cityId
                              ? "Select city first"
                              : "Select Property Type"}
                          </option>
                          {propertyType?.map((option) => (
                            <option value={option._id} key={option._id}>
                              {option?.propertyType}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Available For Dropdown */}
                    <div className="form_field_property">
                      <label className="filter_property_label">
                        Available For
                      </label>
                      <div className="filter_input_div">
                        <select
                          className="filter_input"
                          value={filterData?.propertyFor}
                          onChange={(e) =>
                            handleFilterChange("propertyFor", e.target.value)
                          }
                          disabled={!filterData.cityId}
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        >
                          <option value="">
                            {!filterData.cityId
                              ? "Select city first"
                              : "Select Available For"}
                          </option>
                          {availableFor?.map((option) => (
                            <option value={option.value} key={option.value}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Locality Dropdown with Search */}
                    <div className="form_field_property" ref={localityRef}>
                      <label className="filter_property_label">Locality</label>
                      <div className="filter_input_div">
                        <div className="custom-dropdown">
                          <input
                            type="text"
                            className="filter-input"
                            placeholder={
                              !filterData.cityId
                                ? "Select city first"
                                : filterData.locality
                                  ? cityWiseLocality.find(
                                      (item) =>
                                        item._id === filterData.locality,
                                    )?.name || "Search locality..."
                                  : "Search locality..."
                            }
                            value={
                              showLocalityDropdown
                                ? localitySearchTerm
                                : filterData.locality
                                  ? cityWiseLocality.find(
                                      (item) =>
                                        item._id === filterData.locality,
                                    )?.name || ""
                                  : ""
                            }
                            onChange={(e) => {
                              setLocalitySearchTerm(e.target.value);
                              setShowLocalityDropdown(true);
                            }}
                            onClick={() => {
                              if (filterData.cityId) {
                                setShowLocalityDropdown(!showLocalityDropdown);
                                setLocalitySearchTerm("");
                              }
                            }}
                            disabled={!filterData.cityId}
                            style={{
                              // backgroundColor: !filterData.cityId
                              //   ? "white"
                              //   : "white",
                              cursor: !filterData.cityId
                                ? "not-allowed"
                                : "text",
                              borderRadius: "10px",
                            }}
                          />
                          {showLocalityDropdown && filterData.cityId && (
                            <div
                              className="dropdown-list"
                              style={{
                                overflow: "auto",
                                scrollbarWidth: "none",
                              }}
                            >
                              <div
                                // key={option._id}
                                className={`dropdown-item ${
                                  filterData.locality === "" ? "selected" : ""
                                }`}
                                onClick={() => {
                                  handleFilterChange("locality", "");
                                  setShowLocalityDropdown(false);
                                  setLocalitySearchTerm("");
                                }}
                              >
                                Select Locality
                              </div>
                              {filteredLocalities.length > 0 ? (
                                filteredLocalities.map((option) => (
                                  <div
                                    style={{ fontSize: "12px" }}
                                    key={option._id}
                                    className={`dropdown-item ${
                                      filterData.locality === option._id
                                        ? "selected"
                                        : ""
                                    }`}
                                    onClick={() => {
                                      handleFilterChange(
                                        "locality",
                                        option._id,
                                      );

                                      setShowLocalityDropdown(false);
                                      setLocalitySearchTerm("");
                                    }}
                                  >
                                    {option.name}
                                  </div>
                                ))
                              ) : (
                                <div className="dropdown-item no-results">
                                  No localities found
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Apartment Name Dropdown with Search */}
                    <div className="form_field_property" ref={apartmentRef}>
                      <label className="filter_property_label">
                        Apartment Name
                      </label>
                      <div className="filter_input_div">
                        <div className="custom-dropdown">
                          <input
                            type="text"
                            className="filter-input"
                            placeholder={
                              !filterData.cityId
                                ? "Select city first"
                                : !filterData?.locality
                                  ? "Select Locality First"
                                  : filterData.aptName
                                    ? filterData.aptName
                                    : "Search apartment..."
                            }
                            value={
                              showApartmentDropdown
                                ? apartmentSearchTerm
                                : filterData.aptName || ""
                            }
                            onChange={(e) => {
                              setApartmentSearchTerm(e.target.value);
                              setShowApartmentDropdown(true);
                            }}
                            onClick={() => {
                              if (filterData.cityId) {
                                setShowApartmentDropdown(
                                  !showApartmentDropdown,
                                );
                                setApartmentSearchTerm("");
                              }
                            }}
                            disabled={
                              !filterData.cityId || !filterData?.locality
                            }
                            style={{
                              // backgroundColor: !filterData.cityId
                              //   ? "white"
                              //   : "white",
                              cursor: !filterData.cityId
                                ? "not-allowed"
                                : "text",
                              borderRadius: "10px",
                            }}
                          />
                          {showApartmentDropdown && filterData.cityId && (
                            <div
                              className="dropdown-list"
                              style={{
                                overflow: "auto",
                                scrollbarWidth: "none",
                              }}
                            >
                              <div
                                // key={index}
                                className={`dropdown-item ${
                                  filterData.aptName === "" ? "selected" : ""
                                }`}
                                onClick={() => {
                                  handleFilterChange("aptName", "");
                                  setShowApartmentDropdown(false);
                                  setApartmentSearchTerm("");
                                }}
                              >
                                Select Appartment
                              </div>
                              {filteredApartments.length > 0 ? (
                                filteredApartments
                                  ?.filter(
                                    (item) =>
                                      item?.locality?._id ===
                                      filterData?.locality,
                                  )
                                  ?.map((option, index) => (
                                    <div
                                      style={{ fontSize: "12px" }}
                                      key={index}
                                      className={`dropdown-item ${
                                        filterData.aptName === option.aptName
                                          ? "selected"
                                          : ""
                                      }`}
                                      onClick={() => {
                                        handleFilterChange(
                                          "aptName",
                                          option.aptName,
                                        );
                                        setShowApartmentDropdown(false);
                                        setApartmentSearchTerm("");
                                      }}
                                    >
                                      {option.aptName}
                                    </div>
                                  ))
                              ) : (
                                <div className="dropdown-item no-results">
                                  No apartments found
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Owner Phone Number */}
                    {renderFilterField(
                      "Owner Phone Number",
                      "phoneNo",
                      "input",
                      [],
                      "Enter Owner Phone Number",
                    )}

                    {/* Society name / Address */}
                    {renderFilterField(
                      "Society name / Address",
                      "address",
                      "input",
                      [],
                      "Enter address",
                    )}

                    {/* Area and Unit */}
                    <div
                      className="form_field_property"
                      style={{ display: "flex" }}
                    >
                      <div style={{ flex: 1, marginRight: "10px" }}>
                        <label className="filter_property_label">
                          Minimum Area
                        </label>
                        <div className="filter_input_div">
                          <input
                            className="filter_input"
                            placeholder={
                              !filterData.cityId
                                ? "Select city first"
                                : "Enter Minimum Area"
                            }
                            value={filterData.minArea}
                            onChange={(e) =>
                              handleFilterChange(
                                "minArea",
                                Number(e.target.value),
                              )
                            }
                            disabled={!filterData.cityId}
                            style={{
                              backgroundColor: !filterData.cityId
                                ? "#f5f5f5"
                                : "white",
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ flex: 1, marginRight: "10px" }}>
                        <label className="filter_property_label">
                          Maximum Area
                        </label>
                        <div className="filter_input_div">
                          <input
                            className="filter_input"
                            placeholder={
                              !filterData.cityId
                                ? "Select city first"
                                : !filterData?.minArea
                                  ? "Enter Minimum area first"
                                  : "Enter Maximum Area"
                            }
                            value={filterData.maxArea}
                            onChange={(e) =>
                              handleFilterChange(
                                "maxArea",
                                Number(e.target.value),
                              )
                            }
                            disabled={
                              !filterData.cityId || !filterData?.minArea
                            }
                            style={{
                              backgroundColor: !filterData.cityId
                                ? "#f5f5f5"
                                : "white",
                            }}
                          />
                        </div>
                      </div>
                      {/* <div style={{ flex: 1 }}>
                        <label className="filter_property_label">Unit</label>
                        <div className="filter_input_div">
                          <select
                            disabled={!filterData?.area || !filterData.cityId}
                            className="filter_input"
                            value={filterData?.unit}
                            onChange={(e) =>
                              handleFilterChange("unit", e.target.value)
                            }
                            style={{
                              backgroundColor: !filterData.cityId
                                ? "#f5f5f5"
                                : "white",
                            }}
                          >
                            <option>--Select Unit--</option>
                            <option value="Feet">Feet</option>
                            <option value="Meter">Meter</option>
                            <option value="Yard">Yard</option>
                          </select>
                        </div>
                      </div> */}
                    </div>
                    <div style={{ marginTop: "10px" }}>
                      <label className="filter_property_label">Area Unit</label>
                      <div className="filter_input_div">
                        <select
                          disabled={
                            !filterData?.minArea ||
                            !filterData.cityId ||
                            !filterData?.maxArea
                          }
                          className="filter_input"
                          value={filterData?.unit}
                          onChange={(e) =>
                            handleFilterChange("unit", e.target.value)
                          }
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        >
                          <option>--Select Unit--</option>
                          <option value="Feet">Feet</option>
                          <option value="Meter">Meter</option>
                          <option value="Yard">Yard</option>
                        </select>
                      </div>
                    </div>

                    {/* BHK */}
                    {/* {renderFilterField("BHK", "bhk", "input", [], "Enter BHK")} */}
                    <div style={{ marginTop: "10px" }}>
                      <label className="filter_property_label">BHK</label>
                      <div className="filter_input_div">
                        <select
                          disabled={!filterData.cityId}
                          className="filter_input"
                          value={filterData?.bhk}
                          onChange={(e) =>
                            handleFilterChange("bhk", e.target.value)
                          }
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        >
                          <option value="">--Select BHK--</option>
                          {[
                            "0",
                            "1",
                            "1RK",
                            "2",
                            "2RK",
                            ...Array.from({ length: 33 }, (_, i) =>
                              (i + 3).toString(),
                            ),
                          ]?.map((item) => {
                            return <option value={item}>{item}</option>;
                          })}
                        </select>
                      </div>
                    </div>

                    {/* Floor */}
                    {/* {renderFilterField(
                      "Floor",
                      "floor",
                      "input",
                      [],
                      "Enter Floor",
                    )} */}

                    <div style={{ marginTop: "10px" }}>
                      <label className="filter_property_label">Floor</label>
                      <div className="filter_input_div">
                        <select
                          disabled={!filterData.cityId}
                          className="filter_input"
                          value={filterData?.floor}
                          onChange={(e) =>
                            handleFilterChange("floor", e.target.value)
                          }
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        >
                          <option value="">--Select Floor--</option>
                          {floors?.map((item) => {
                            return <option value={item}>{item}</option>;
                          })}
                        </select>
                      </div>
                    </div>

                    {/* Owner Name */}

                    <div
                      style={{
                        flex: 1,
                        marginTop: "10px",
                        position: "relative",
                      }}
                    >
                      <label className="filter_property_label">
                        Owner Name
                      </label>
                      <div className="filter_input_div">
                        <input
                          onClick={() => {
                            setIsOwnerNameInputClicked(
                              !isOwnerNameInputClicked,
                            );
                          }}
                          className="filter_input"
                          placeholder={
                            !filterData.cityId
                              ? "Select city first"
                              : "Enter Owner Name"
                          }
                          value={filterData.name}
                          onChange={(e) =>
                            handleFilterChange("name", e.target.value)
                          }
                          disabled={!filterData.cityId}
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        />
                      </div>
                      {isOwnerNameInputClicked && (
                        <div
                          ref={ownerRef}
                          style={{
                            position: "absolute",
                            width: "100%",
                            height: "500%",
                            border: "none",
                            borderRadius: "5px",
                            backgroundColor: "white",
                            padding: "5px 10px",
                            overflow: "scroll",
                            zIndex: "999",
                          }}
                        >
                          {fetchOwnerNamesLoading ? (
                            <p style={{ color: "black", marginTop: "8px" }}>
                              Loading...
                            </p>
                          ) : (
                            ownerNames?.map((item) => {
                              return (
                                <p
                                  style={{
                                    color: "black",
                                    marginTop: "8px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    handleFilterChange("name", item?.name);
                                    setIsOwnerNameInputClicked(false);
                                  }}
                                >
                                  {item?.name}
                                </p>
                              );
                            })
                          )}
                        </div>
                      )}
                    </div>

                    {/* features */}

                    <div style={{ marginTop: "10px" }}>
                      <label className="filter_property_label">Features</label>
                      <div className="filter_input_div">
                        <select
                          disabled={!filterData.cityId}
                          className="filter_input"
                          value={filterData?.features}
                          onChange={(e) =>
                            handleFilterChange("features", e.target.value)
                          }
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        >
                          <option value="">--Select Features--</option>
                          <option value="Swimming Pool">Swimming Pool</option>
                          <option value="Gym">Gym</option>
                          <option value="Lift">Lift</option>
                          <option value="Parking">Parking</option>
                        </select>
                      </div>
                    </div>

                    {/* Price Slider */}
                    {renderPriceSlider()}

                    {/* Price Dropdowns - Only show when price filter is active */}
                    {isPriceFilterActive && (
                      <div
                        className="form_field_property"
                        style={{ display: "flex", gap: "12px" }}
                      >
                        <div className="filter_input_div" style={{ flex: 1 }}>
                          <select
                            className="filter_input"
                            onChange={(e) =>
                              setMinValue(Number(e.target.value))
                            }
                            value={minValue}
                          >
                            <option value="0">Min Price</option>
                            {priceOptions.map((val) => (
                              <option
                                key={val}
                                value={val}
                                disabled={maxValue !== 0 && val > maxValue}
                              >
                                {formatValue(val)}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="filter_input_div" style={{ flex: 1 }}>
                          <select
                            className="filter_input"
                            onChange={(e) =>
                              setMaxValue(Number(e.target.value))
                            }
                            value={maxValue}
                          >
                            <option value="0">Max Price</option>
                            {priceOptions.map((val) => (
                              <option
                                key={val}
                                value={val}
                                disabled={minValue !== 0 && val < minValue}
                              >
                                {formatValue(val)}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                  </form>
                </div>

                {/* Mobile Filter Modal */}
                {show && (
                  <>
                    <div
                      onClick={() => setshow(!show)}
                      className="modal_filter_div"
                    />
                    <div className="filter_property_div5">
                      <div className="filter_div_head">
                        <p className="filter_by_para">Filter by</p>
                        <p
                          className="clear_all_para"
                          style={{ cursor: "pointer" }}
                          // onClick={handleClearAll}
                          onClick={() => setshow(false)}
                        >
                          {/* Clear All */}
                          Apply
                        </p>
                      </div>
                      <div className="property_filter_form_wrapper">
                        <form>
                          {/* City Dropdown */}
                          <div className="form_field_property">
                            <label className="filter_property_label">
                              City
                            </label>
                            <div className="filter_input_div">
                              <select
                                className="filter_input"
                                value={filterData?.cityId}
                                onChange={(e) =>
                                  handleFilterChange("cityId", e.target.value)
                                }
                              >
                                <option value="">Select City</option>
                                {city?.map((option) => (
                                  <option value={option._id} key={option._id}>
                                    {option?.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          {/* Property Type Dropdown */}
                          <div className="form_field_property">
                            <label className="filter_property_label">
                              Property Type
                            </label>
                            <div className="filter_input_div">
                              <select
                                className="filter_input"
                                value={filterData?.propertyType}
                                onChange={(e) =>
                                  handleFilterChange(
                                    "propertyType",
                                    e.target.value,
                                  )
                                }
                                disabled={!filterData.cityId}
                                style={{
                                  backgroundColor: !filterData.cityId
                                    ? "#f5f5f5"
                                    : "white",
                                }}
                              >
                                <option value="">
                                  {!filterData.cityId
                                    ? "Select city first"
                                    : "Select Property Type"}
                                </option>
                                {propertyType?.map((option) => (
                                  <option value={option._id} key={option._id}>
                                    {option?.propertyType}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          {/* Available For Dropdown */}
                          <div className="form_field_property">
                            <label className="filter_property_label">
                              Available For
                            </label>
                            <div className="filter_input_div">
                              <select
                                className="filter_input"
                                value={filterData?.propertyFor}
                                onChange={(e) =>
                                  handleFilterChange(
                                    "propertyFor",
                                    e.target.value,
                                  )
                                }
                                disabled={!filterData.cityId}
                                style={{
                                  backgroundColor: !filterData.cityId
                                    ? "#f5f5f5"
                                    : "white",
                                }}
                              >
                                <option value="">
                                  {!filterData.cityId
                                    ? "Select city first"
                                    : "Select Available For"}
                                </option>
                                {availableFor?.map((option) => (
                                  <option
                                    value={option.value}
                                    key={option.value}
                                  >
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          {/* Locality Dropdown with Search */}
                          <div
                            className="form_field_property"
                            ref={localityRef}
                          >
                            <label className="filter_property_label">
                              Locality
                            </label>
                            <div className="filter_input_div">
                              <div className="custom-dropdown">
                                <input
                                  type="text"
                                  className="filter-input"
                                  placeholder={
                                    !filterData.cityId
                                      ? "Select city first"
                                      : filterData.locality
                                        ? cityWiseLocality.find(
                                            (item) =>
                                              item._id === filterData.locality,
                                          )?.name || "Search locality..."
                                        : "Search locality..."
                                  }
                                  value={
                                    showLocalityDropdown
                                      ? localitySearchTerm
                                      : filterData.locality
                                        ? cityWiseLocality.find(
                                            (item) =>
                                              item._id === filterData.locality,
                                          )?.name || ""
                                        : ""
                                  }
                                  onChange={(e) => {
                                    setLocalitySearchTerm(e.target.value);
                                    setShowLocalityDropdown(true);
                                  }}
                                  onClick={() => {
                                    if (filterData.cityId) {
                                      setShowLocalityDropdown(
                                        !showLocalityDropdown,
                                      );
                                      setLocalitySearchTerm("");
                                    }
                                  }}
                                  disabled={!filterData.cityId}
                                  style={{
                                    // backgroundColor: !filterData.cityId
                                    //   ? "white"
                                    //   : "white",
                                    cursor: !filterData.cityId
                                      ? "not-allowed"
                                      : "text",
                                    borderRadius: "10px",
                                  }}
                                />
                                {showLocalityDropdown && filterData.cityId && (
                                  <div
                                    className="dropdown-list"
                                    style={{
                                      overflow: "auto",
                                      scrollbarWidth: "none",
                                    }}
                                  >
                                    <div
                                      // key={option._id}
                                      className={`dropdown-item ${
                                        filterData.locality === ""
                                          ? "selected"
                                          : ""
                                      }`}
                                      onClick={() => {
                                        handleFilterChange("locality", "");
                                        setShowLocalityDropdown(false);
                                        setLocalitySearchTerm("");
                                      }}
                                    >
                                      Select Locality
                                    </div>
                                    {filteredLocalities.length > 0 ? (
                                      filteredLocalities.map((option) => (
                                        <div
                                          style={{ fontSize: "12px" }}
                                          key={option._id}
                                          className={`dropdown-item ${
                                            filterData.locality === option._id
                                              ? "selected"
                                              : ""
                                          }`}
                                          onClick={() => {
                                            handleFilterChange(
                                              "locality",
                                              option._id,
                                            );
                                            setShowLocalityDropdown(false);
                                            setLocalitySearchTerm("");
                                          }}
                                        >
                                          {option.name}
                                        </div>
                                      ))
                                    ) : (
                                      <div className="dropdown-item no-results">
                                        No localities found
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Apartment Name Dropdown with Search */}
                          <div
                            className="form_field_property"
                            ref={apartmentRef}
                          >
                            <label className="filter_property_label">
                              Apartment Name
                            </label>
                            <div className="filter_input_div">
                              <div className="custom-dropdown">
                                <input
                                  type="text"
                                  className="filter-input"
                                  placeholder={
                                    !filterData.cityId
                                      ? "Select city first"
                                      : filterData.aptName
                                        ? filterData.aptName
                                        : "Search apartment..."
                                  }
                                  value={
                                    showApartmentDropdown
                                      ? apartmentSearchTerm
                                      : filterData.aptName || ""
                                  }
                                  onChange={(e) => {
                                    setApartmentSearchTerm(e.target.value);
                                    setShowApartmentDropdown(true);
                                  }}
                                  onClick={() => {
                                    if (filterData.cityId) {
                                      setShowApartmentDropdown(
                                        !showApartmentDropdown,
                                      );
                                      setApartmentSearchTerm("");
                                    }
                                  }}
                                  disabled={!filterData.cityId}
                                  style={{
                                    // backgroundColor: !filterData.cityId
                                    //   ? "white"
                                    //   : "white",
                                    cursor: !filterData.cityId
                                      ? "not-allowed"
                                      : "text",
                                    borderRadius: "10px",
                                  }}
                                />
                                {showApartmentDropdown && filterData.cityId && (
                                  <div
                                    className="dropdown-list"
                                    style={{
                                      overflow: "auto",
                                      scrollbarWidth: "none",
                                    }}
                                  >
                                    <div
                                      // key={index}
                                      className={`dropdown-item ${
                                        filterData.aptName === ""
                                          ? "selected"
                                          : ""
                                      }`}
                                      onClick={() => {
                                        handleFilterChange("aptName", "");
                                        setShowApartmentDropdown(false);
                                        setApartmentSearchTerm("");
                                      }}
                                    >
                                      Select Appartment
                                    </div>
                                    {filteredApartments.length > 0 ? (
                                      filteredApartments.map(
                                        (option, index) => (
                                          <div
                                            style={{ fontSize: "12px" }}
                                            key={index}
                                            className={`dropdown-item ${
                                              filterData.aptName ===
                                              option.aptName
                                                ? "selected"
                                                : ""
                                            }`}
                                            onClick={() => {
                                              handleFilterChange(
                                                "aptName",
                                                option.aptName,
                                              );
                                              setShowApartmentDropdown(false);
                                              setApartmentSearchTerm("");
                                            }}
                                          >
                                            {option.aptName}
                                          </div>
                                        ),
                                      )
                                    ) : (
                                      <div className="dropdown-item no-results">
                                        No apartments found
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Owner Phone Number */}
                          {renderFilterField(
                            "Owner Phone Number",
                            "phoneNo",
                            "input",
                            [],
                            "Enter Owner Phone Number",
                          )}

                          {/* Society name / Address */}
                          {renderFilterField(
                            "Society name / Address",
                            "address",
                            "input",
                            [],
                            "Enter address",
                          )}

                          {/* Area and Unit */}
                          <div
                            className="form_field_property"
                            style={{ display: "flex" }}
                          >
                            <div style={{ flex: 1, marginRight: "10px" }}>
                              <label className="filter_property_label">
                                Minimum Area
                              </label>
                              <div className="filter_input_div">
                                <input
                                  className="filter_input"
                                  placeholder={
                                    !filterData.cityId
                                      ? "Select city first"
                                      : "Enter Value"
                                  }
                                  value={filterData.minArea}
                                  onChange={(e) =>
                                    handleFilterChange(
                                      "minArea",
                                      Number(e.target.value),
                                    )
                                  }
                                  disabled={!filterData.cityId}
                                  style={{
                                    backgroundColor: !filterData.cityId
                                      ? "#f5f5f5"
                                      : "white",
                                  }}
                                />
                              </div>
                            </div>
                            <div style={{ flex: 1 }}>
                              <label className="filter_property_label">
                                Maximun Area
                              </label>
                              <div className="filter_input_div">
                                <select
                                  disabled={
                                    !filterData?.minArea || !filterData.cityId
                                  }
                                  className="filter_input"
                                  value={filterData?.maxArea}
                                  onChange={(e) =>
                                    handleFilterChange(
                                      "maxArea",
                                      e.target.value,
                                    )
                                  }
                                  style={{
                                    backgroundColor: !filterData.cityId
                                      ? "#f5f5f5"
                                      : "white",
                                  }}
                                >
                                  <option>--Select Unit--</option>
                                  <option value="ft">Ft</option>
                                  <option value="Meter">Meter</option>
                                  <option value="Yard">Yard</option>
                                </select>
                              </div>
                            </div>
                            <div style={{ flex: 1 }}>
                              <label className="filter_property_label">
                                Unit
                              </label>
                              <div className="filter_input_div">
                                <select
                                  disabled={
                                    !filterData?.area || !filterData.cityId
                                  }
                                  className="filter_input"
                                  value={filterData?.unit}
                                  onChange={(e) =>
                                    handleFilterChange("unit", e.target.value)
                                  }
                                  style={{
                                    backgroundColor: !filterData.cityId
                                      ? "#f5f5f5"
                                      : "white",
                                  }}
                                >
                                  <option>--Select Unit--</option>
                                  <option value="ft">Ft</option>
                                  <option value="Meter">Meter</option>
                                  <option value="Yard">Yard</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          {/* BHK */}
                          {renderFilterField(
                            "BHK",
                            "bhk",
                            "input",
                            [],
                            "Enter BHK",
                          )}

                          {/* Floor */}
                          {renderFilterField(
                            "Floor",
                            "floor",
                            "input",
                            [],
                            "Enter Floor",
                          )}

                          {/* Price Slider */}
                          {renderPriceSlider()}

                          {/* Price Dropdowns - Only show when price filter is active */}
                          {isPriceFilterActive && (
                            <div
                              className="form_field_property"
                              style={{ display: "flex", gap: "12px" }}
                            >
                              <div
                                className="filter_input_div"
                                style={{ flex: 1 }}
                              >
                                <select
                                  className="filter_input"
                                  onChange={(e) =>
                                    setMinValue(Number(e.target.value))
                                  }
                                  value={minValue}
                                >
                                  <option value="0">Min Price</option>
                                  {priceOptions.map((val) => (
                                    <option
                                      key={val}
                                      value={val}
                                      disabled={
                                        maxValue !== 0 && val > maxValue
                                      }
                                    >
                                      {formatValue(val)}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div
                                className="filter_input_div"
                                style={{ flex: 1 }}
                              >
                                <select
                                  className="filter_input"
                                  onChange={(e) =>
                                    setMaxValue(Number(e.target.value))
                                  }
                                  value={maxValue}
                                >
                                  <option value="0">Max Price</option>
                                  {priceOptions.map((val) => (
                                    <option
                                      key={val}
                                      value={val}
                                      disabled={
                                        minValue !== 0 && val < minValue
                                      }
                                    >
                                      {formatValue(val)}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          )}
                        </form>

                        {/* Mobile filter form would go here with same logic */}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add CSS for dropdowns */}
      <style jsx>{`
        .custom-dropdown {
          position: relative;
          width: 100%;
        }
        .filter-input {
          width: 100%;
          padding: 8px 12px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
        }
        .filter-input:focus {
          outline: none;
          border-color: #007bff;
        }
        .dark .filter-input {
          background: var(--ws-blue-input);
          color: var(--ws-blue-foreground);
          border-color: var(--ws-blue-border);
        }
        .dropdown-list {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          max-height: 250px;
          overflow-y: auto;
          background: white;
          border: 1px solid #ddd;
          border-radius: 4px;
          margin-top: 2px;
          z-index: 1000;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }
        .dropdown-item {
          padding: 8px 12px;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        .dropdown-item:hover {
          background-color: #f0f0f0;
        }
        .dropdown-item.selected {
          background-color: #e3f2fd;
          color: #007bff;
        }
        .dropdown-item.no-results {
          color: #999;
          cursor: default;
        }
        .dropdown-item.no-results:hover {
          background-color: white;
        }
      `}</style>
    </>
  );
};

export default PropertyList;
